<template>
  <!-- 1.all-container-start -->
  <div class="all-container" v-if="show">
    <div class="main flexStyle1">
      <div class="center">
        <div class="top">提示</div>
        <div class="bottom">{{ showContent }}</div>
        <div @click="close" class="close c-animation">关闭</div>
      </div>
    </div>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
export default {
  data() {
    // 1.data
    return {
      show: false, // 1.1.显示开关
      show_info: "兑换成功", // 1.2.显示内容
    };
  },

  methods: {
    // 2.methods
    close() {
      // 2.1.关闭
      this.show = false;
      this.$router.push("/");
    },
  },

  props: {
    // 3.props
    isShow: {
      // 3.1.是否显示
      type: Boolean,
      default: false,
      deep: true,
    },

    showContent: {
      // 3.2.显示内容
      type: String,
      default: '兑换成功'
    },
  },

  watch: {
    // 4.watch
    isShow() {
      // 4.1.监听isShow
      this.show = this.isShow;
    },
    showContent() {
      // 4.1.监听showContent
      this.show_info = this.showContent;
    },
  },

  mounted() {
    this.show = this.isShow;
    this.info = this.showContent;
  },
};
</script>

<style lang="scss" scoped>
/* 1.all-container-style-start */
.all-container {
  > .main {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba($color: #000000, $alpha: 0.4);
    z-index: 999;

    > .center {
      background-color: #fff;
      border-radius: 6px;
      width: 500px;
      box-sizing: border-box;
      padding: 20px 20px 40px;
      font-size: 13px;
      position: relative;

      > .top {
        text-align: center;
        font-size: 18px;
        margin-bottom: 20px;
      }

      > .bottom {
        text-align: center;
      }

      > .close {
        position: absolute;
        top: 20px;
        right: 20px;
        color: #f00;
      }
    }
  }
}
/* 1.all-container-style-end */
</style>
